/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { createContext, useContext } from "react";

import { CustomPlayerProps } from "../shared/types";

export interface CustomPlayerContextValue {
  onFetchMedia?: CustomPlayerProps["onFetchMedia"];
  onNavigateToMedia?: CustomPlayerProps["onNavigateToMedia"];
  onAnalyticsEvent?: CustomPlayerProps["onAnalyticsEvent"];
  onLoadStartPosition?: CustomPlayerProps["onLoadStartPosition"];
  onPlayerMount?: CustomPlayerProps["onPlayerMount"];
  skipContinueWatching?: boolean;
  chromecastReceiverId?: string;
  withCredentials?: boolean;
  sentryDsn?: string;
  liveTuning?: CustomPlayerProps["liveTuning"];
  liveScreens?: CustomPlayerProps["liveScreens"];
  plugins?: CustomPlayerProps["plugins"];
}

const CustomPlayerContext = createContext<CustomPlayerContextValue>({});

export const CustomPlayerContextProvider: React.FC<{
  value: CustomPlayerContextValue;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <CustomPlayerContext.Provider value={value}>
      {children}
    </CustomPlayerContext.Provider>
  );
};

export const useCustomPlayerContext = (): CustomPlayerContextValue =>
  useContext(CustomPlayerContext);
